// src/components/filter-group/radio-item.tsx
import { tv } from "tailwind-variants";
import { jsx, jsxs } from "react/jsx-runtime";
var radioItemStyles = tv({
  slots: {
    base: "text-base font-normal text-neutral-800 flex items-center gap-2 cursor-pointer mb-2",
    container: "relative flex items-center justify-center has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-secondary transition-all duration-500 ease-out",
    input: "peer m-1 appearance-none w-4 h-4 border border-secondary rounded-full bg-main shrink-0 focus-visible:outline-none transition disabled:cursor-not-allowed disabled:border-neutral-400",
    icon: "flex items-center justify-center bg-secondary rounded-full fill-main absolute w-2 h-2 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 peer-checked:opacity-100 transition-all duration-500 ease-out peer-disabled:cursor-not-allowed",
    description: "ml-auto"
  }
});
var RadioItem = ({
  name,
  value,
  label,
  description,
  checked,
  defaultChecked,
  onChange,
  disabled,
  className,
  required
}) => {
  const style = radioItemStyles();
  return /* @__PURE__ */ jsxs("label", { className: style.base({ className }), children: [
    /* @__PURE__ */ jsxs("span", { className: style.container(), children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          type: "radio",
          name,
          value: value ?? label,
          checked,
          defaultChecked,
          onChange,
          disabled,
          className: style.input(),
          required
        }
      ),
      /* @__PURE__ */ jsx("span", { className: style.icon() })
    ] }),
    /* @__PURE__ */ jsx("span", { children: label }),
    description && /* @__PURE__ */ jsx("span", { className: style.description(), children: description })
  ] });
};
RadioItem.displayName = "RadioItem";
export {
  RadioItem
};
